import {DEFAULT_POINT_COLOR} from '@wandb/weave/common/util/SdkPointCloudToBabylon';
import {Select} from '@wandb/weave/components/Form/Select';
import Color from 'color';
import React from 'react';

import ColorPicker from '../../../../../ColorPicker';
import {PointColorSetting} from '../../../../../PanelMediaBrowser/common';
import {SettingTitle} from '../../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';

type PointColorSettingType = PointColorSetting['type'] | 'default';
type PointColorSettingOption = {
  label: string;
  value: PointColorSettingType;
};
const DEFAULT_OPTION: PointColorSettingOption = {
  label: 'Default logged color',
  value: 'default',
};
const POINT_COLOR_SETTING_OPTIONS: PointColorSettingOption[] = [
  DEFAULT_OPTION,
  {label: 'Custom color', value: 'rgb'},
];

export const PointColor = () => {
  const {updateConfig, config, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const pointColorSetting = config.pointColor;
  const rgbColor =
    pointColorSetting?.type === 'rgb' ? pointColorSetting.color : undefined;
  const pointColor =
    rgbColor && rgbColor.length === 3 && rgbColor.every(c => c !== undefined)
      ? `rgb(${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]})`
      : undefined;
  const setColor = (color: string) => {
    const chosenColor = Color(color);
    updateConfig({
      pointColor: {
        type: 'rgb',
        color: [chosenColor.red(), chosenColor.green(), chosenColor.blue()],
      },
    });
  };
  return (
    <div className="flex flex-col">
      <SettingTitle title="Point color" />
      <div className="flex">
        <Select<PointColorSettingOption>
          className="w-full"
          options={POINT_COLOR_SETTING_OPTIONS}
          value={
            POINT_COLOR_SETTING_OPTIONS.find(
              option => option.value === pointColorSetting?.type
            ) ?? DEFAULT_OPTION
          }
          onChange={value => {
            if (value) {
              if (value.value === 'default') {
                unsetConfigField('pointColor');
              } else if (value.value === 'rgb') {
                updateConfig({
                  pointColor: {
                    type: 'rgb',
                    color: DEFAULT_POINT_COLOR,
                  },
                });
              } else {
                updateConfig({pointColor: {type: value.value}});
              }
            }
          }}
        />
        {pointColor && (
          <div className="ml-8">
            <ColorPicker
              activeColor={pointColor}
              setColor={setColor}
              trigger="button"
            />
          </div>
        )}
      </div>
    </div>
  );
};
